// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gR","advertCardFooter__row":"c-a_gS","advertCardFooter__name":"c-a_gT","advertCardFooter__price":"c-a_gU","advertCardFooter__age":"c-a_gV"};